<template>
  <div class="pff">
    <!-- Reason chips — toggle on/off, sent as an array. The list comes from the
         office's REVIEWS_SETTINGS.privateFeedback.reasons (server validates the
         subset again on submit). -->
    <div v-if="reasons && reasons.length" class="pff-chips">
      <button
        v-for="reason in reasons"
        :key="reason"
        type="button"
        class="pff-chip"
        :class="{ active: isSelected(reason) }"
        @click="toggle(reason)"
      >
        {{ reason }}
      </button>
    </div>

    <!-- Optional free-text note. Native textarea per house rules; the backend
         caps at 2000 chars — mirror it here so nothing is silently truncated. -->
    <textarea
      v-model="note"
      class="pff-note"
      maxlength="2000"
      placeholder="Tell us more (optional)…"
    ></textarea>

    <div v-if="error" class="pff-error">{{ error }}</div>

    <button
      type="button"
      class="pff-submit"
      :disabled="submitting"
      @click="onSubmit"
    >
      <span v-if="submitting"><i class="fa fa-circle-o-notch fa-spin"></i> Sending…</span>
      <span v-else>Send to the office</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PrivateFeedbackForm',
  props: {
    reasons: { type: Array, default: () => [] },
    submitting: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  data() {
    return {
      selected: [],
      note: '',
    };
  },
  methods: {
    isSelected(reason) {
      return this.selected.includes(reason);
    },
    toggle(reason) {
      if (this.isSelected(reason)) {
        this.selected = this.selected.filter((r) => r !== reason);
      } else {
        this.selected = [...this.selected, reason];
      }
    },
    onSubmit() {
      if (this.submitting) return;
      this.$emit('submit', {
        reasons: this.selected,
        note: this.note.trim().slice(0, 2000),
      });
    },
  },
};
</script>

<style scoped>
.pff-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-bottom: 18px;
}
.pff-chip {
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 600;
  padding: 7px 13px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  transition: all 0.12s ease;
}
.pff-chip:hover {
  border-color: #cbd5e1;
}
.pff-chip.active {
  border-color: #0d5f54;
  background: #e6f2f0;
  color: #0d5f54;
}
.pff-note {
  width: 100%;
  min-height: 90px;
  resize: none;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 11px 13px;
  font-family: inherit;
  font-size: 13.5px;
  line-height: 1.5;
  box-sizing: border-box;
  margin-bottom: 16px;
  color: #0f172a;
}
.pff-note:focus {
  outline: none;
  border-color: #0d5f54;
  box-shadow: 0 0 0 3px rgba(13, 95, 84, 0.12);
}
.pff-error {
  font-size: 12.5px;
  color: #dc2626;
  margin-bottom: 12px;
  text-align: center;
}
.pff-submit {
  width: 100%;
  border: none;
  cursor: pointer;
  font-family: inherit;
  background: #0d5f54;
  color: #ffffff;
  border-radius: 12px;
  padding: 13px;
  font-size: 14px;
  font-weight: 700;
  transition: background 0.12s ease;
}
.pff-submit:hover:not(:disabled) {
  background: #0a4d44;
}
.pff-submit:disabled {
  opacity: 0.7;
  cursor: default;
}
</style>
